import { useEffect } from 'react';
import { useIsLoggedIn } from 'hooks/user/useIsLoggedIn';
import { useAppDispatch } from 'appRedux/hooks';
import {
  bulkAddToCart,
  getCart,
  removeBulkFromCart
} from 'appRedux/restApi/Cart';
import { store } from 'appRedux/store';

export const useUpdateCartData = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useIsLoggedIn();

  useEffect(() => {
    if (isLoggedIn) {
      const {
        data: localCartData,
        info: { created_at }
      } = store.getState().cart;

      const localCartIds = localCartData.map(nft => nft.id);
      const removeCartIds = localCartData
        .filter(item => item.is_saleable === 0)
        .map(item => item.id);

      if (!created_at && localCartIds.length > 0) {
        dispatch(bulkAddToCart(localCartIds));
      } else {
        dispatch(getCart());
      }
      if (removeCartIds.length > 0) {
        dispatch(removeBulkFromCart(removeCartIds));
      }
    }
  }, [isLoggedIn]);

  return null;
};
